import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const Authmiddleware = (props) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const isLocked = localStorage.getItem('isLocked');
    if (isLocked === 'true') {
      return <Navigate to="/auth-lock-screen" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
